import { type ItemState, StatusGlyph } from '@viko/transcript-ui'
import { BARK_GLYPH_LABEL, type BarkGlyph as Glyph } from '../../lib/bark-aggregate.js'

/** Row status glyph: shape + colour + an accessible label (never colour alone). */
const STATE: Record<Glyph, ItemState> = {
  triaging: 'pending',
  active: 'streaming',
  'needs-you': 'awaiting-user',
  done: 'ok',
  failed: 'error',
  undone: 'cancelled',
}

export function BarkGlyph({ glyph, size = 14 }: { glyph: Glyph; size?: number }) {
  return (
    <span className={`flex-none translate-y-[2px] ${glyph === 'triaging' ? 'vk-bark-spin' : ''}`}>
      <StatusGlyph state={STATE[glyph]} size={size} label={BARK_GLYPH_LABEL[glyph]} />
    </span>
  )
}
